import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { ServiceResponse } from "@appcore/data";
import { NewProduct, Product, RelatedProductLines } from "@data/product";
import { API } from "@service/system/api.service";
import { ResponseHandler } from "@service/system/responseHandler.service";

const API_URL = API.API_URL;

@Injectable()
export class ProductsService {
	private _productsURL = `${API_URL}/product`;

	constructor(private responseHandler: ResponseHandler) {}

	getProducts(simple: boolean = false): Observable<ServiceResponse<Product[]>> {
		return this.responseHandler.httpGet<Product[]>(`${this._productsURL}s`, {simple: simple});
	}

	setProduct(itemID: string, body: Product): Observable<any> {
		return this.responseHandler.httpPost<any>(`${this._productsURL}/${itemID}/set`, body);
	}

	getProductTreeFlatByString(searchString: string | string[]): Observable<any> {
		searchString = searchString == null ? "" : searchString;
		return this.responseHandler.httpGet<any>(`${this._productsURL}s/tree/find`, { searchString: searchString });
	}

	getProductBySearchString(searchString: string | string[], active: boolean): Observable<ServiceResponse<Product[]>> {
		searchString = searchString == null ? "" : searchString;
		return this.responseHandler.httpGet<Product[]>(`${this._productsURL}/find`, {
			searchString: searchString,
			active: active
		});
	}

	insertVersion(prodItemID: string, typeId: number): Observable<any> {
		return this.responseHandler.httpPost<any>(`${this._productsURL}/${prodItemID}/insert/${typeId}`, {});
	}

	// UNDONE: "Future functionality to be implemented and modified by the media asset manager."
	insertDeliverableVersion(prodItemID: string): Observable<any> {
		console.error("insertDeliverableVersion prodItemID: " + prodItemID);
		return throwError("UNDONE: Not implemented. Scheduled for media asset manager task.");
		//return this.httpManager.httpPost<any>(`${this._productsURL}/${prodItemID}/insert/deliverableversion`, null);
	}

	insertProduct(body: Product): Observable<ServiceResponse<NewProduct>> {
		return this.responseHandler.httpPost<NewProduct>(`${this._productsURL}/add`, body);
	}

	getRelatedProductLines(productItemID: string | string[]): Observable<ServiceResponse<RelatedProductLines[]>> {
		return this.responseHandler.httpGet<RelatedProductLines[]>(`${this._productsURL}/${productItemID}/related`, {

		});
	}
}
